export default __webpack_public_path__ + "static/media/Rectangle1.df94a11d.png";